@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(21_712_755)
internal val Res.string.operational_add_supplier: StringResource by lazy {
      StringResource("string:operational_add_supplier", "operational_add_supplier", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30430, 60),
      ))
    }

@delegate:ResourceContentHash(-974_576_687)
internal val Res.string.operational_approved_info: StringResource by lazy {
      StringResource("string:operational_approved_info", "operational_approved_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30491, 69),
      ))
    }

@delegate:ResourceContentHash(48_442_058)
internal val Res.string.operational_approved_success: StringResource by lazy {
      StringResource("string:operational_approved_success", "operational_approved_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30561, 64),
      ))
    }

@delegate:ResourceContentHash(-747_396_985)
internal val Res.string.operational_back: StringResource by lazy {
      StringResource("string:operational_back", "operational_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30626, 32),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.operational_cancel: StringResource by lazy {
      StringResource("string:operational_cancel", "operational_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30659, 38),
      ))
    }

@delegate:ResourceContentHash(-2_137_438_734)
internal val Res.string.operational_clear_confirm: StringResource by lazy {
      StringResource("string:operational_clear_confirm", "operational_clear_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30698, 41),
      ))
    }

@delegate:ResourceContentHash(778_469_755)
internal val Res.string.operational_clear_message: StringResource by lazy {
      StringResource("string:operational_clear_message", "operational_clear_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30740, 181),
      ))
    }

@delegate:ResourceContentHash(1_326_864_692)
internal val Res.string.operational_clear_title: StringResource by lazy {
      StringResource("string:operational_clear_title", "operational_clear_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30922, 47),
      ))
    }

@delegate:ResourceContentHash(-2_136_574_886)
internal val Res.string.operational_col_line: StringResource by lazy {
      StringResource("string:operational_col_line", "operational_col_line", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30970, 36),
      ))
    }

@delegate:ResourceContentHash(-1_703_224_615)
internal val Res.string.operational_col_total: StringResource by lazy {
      StringResource("string:operational_col_total", "operational_col_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31007, 45),
      ))
    }

@delegate:ResourceContentHash(1_326_493_253)
internal val Res.string.operational_company_label: StringResource by lazy {
      StringResource("string:operational_company_label", "operational_company_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31053, 45),
      ))
    }

@delegate:ResourceContentHash(1_539_054_651)
internal val Res.string.operational_complaint_actions: StringResource by lazy {
      StringResource("string:operational_complaint_actions", "operational_complaint_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31099, 49),
      ))
    }

@delegate:ResourceContentHash(-1_701_435_752)
internal val Res.string.operational_complaint_add: StringResource by lazy {
      StringResource("string:operational_complaint_add", "operational_complaint_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31149, 65),
      ))
    }

@delegate:ResourceContentHash(1_815_879_383)
internal val Res.string.operational_complaint_col_date: StringResource by lazy {
      StringResource("string:operational_complaint_col_date", "operational_complaint_col_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31215, 46),
      ))
    }

@delegate:ResourceContentHash(-1_388_323_554)
internal val Res.string.operational_complaint_col_description: StringResource by lazy {
      StringResource("string:operational_complaint_col_description", "operational_complaint_col_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31262, 61),
      ))
    }

@delegate:ResourceContentHash(747_749_642)
internal val Res.string.operational_complaint_col_directorate: StringResource by lazy {
      StringResource("string:operational_complaint_col_directorate", "operational_complaint_col_directorate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31324, 57),
      ))
    }

@delegate:ResourceContentHash(1_323_502_045)
internal val Res.string.operational_complaint_col_manager: StringResource by lazy {
      StringResource("string:operational_complaint_col_manager", "operational_complaint_col_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31382, 53),
      ))
    }

@delegate:ResourceContentHash(-91_853_887)
internal val Res.string.operational_complaint_col_nature: StringResource by lazy {
      StringResource("string:operational_complaint_col_nature", "operational_complaint_col_nature", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31436, 72),
      ))
    }

@delegate:ResourceContentHash(-164_376_766)
internal val Res.string.operational_complaint_col_owner: StringResource by lazy {
      StringResource("string:operational_complaint_col_owner", "operational_complaint_col_owner", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31509, 75),
      ))
    }

@delegate:ResourceContentHash(1_326_493_253)
internal val Res.string.operational_complaint_col_restaurant: StringResource by lazy {
      StringResource("string:operational_complaint_col_restaurant", "operational_complaint_col_restaurant", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31585, 56),
      ))
    }

@delegate:ResourceContentHash(-1_588_655_418)
internal val Res.string.operational_complaint_col_service: StringResource by lazy {
      StringResource("string:operational_complaint_col_service", "operational_complaint_col_service", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31642, 53),
      ))
    }

@delegate:ResourceContentHash(1_610_468_133)
internal val Res.string.operational_complaint_col_shift: StringResource by lazy {
      StringResource("string:operational_complaint_col_shift", "operational_complaint_col_shift", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31696, 47),
      ))
    }

@delegate:ResourceContentHash(-1_720_241_764)
internal val Res.string.operational_complaint_col_status: StringResource by lazy {
      StringResource("string:operational_complaint_col_status", "operational_complaint_col_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31744, 48),
      ))
    }

@delegate:ResourceContentHash(1_742_427_327)
internal val Res.string.operational_complaint_col_supplier: StringResource by lazy {
      StringResource("string:operational_complaint_col_supplier", "operational_complaint_col_supplier", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31793, 58),
      ))
    }

@delegate:ResourceContentHash(-1_041_039_508)
internal val Res.string.operational_complaint_col_time: StringResource by lazy {
      StringResource("string:operational_complaint_col_time", "operational_complaint_col_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31852, 46),
      ))
    }

@delegate:ResourceContentHash(152_872_706)
internal val Res.string.operational_complaint_col_treatment: StringResource by lazy {
      StringResource("string:operational_complaint_col_treatment", "operational_complaint_col_treatment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31899, 55),
      ))
    }

@delegate:ResourceContentHash(-2_051_160_500)
internal val Res.string.operational_complaint_delete: StringResource by lazy {
      StringResource("string:operational_complaint_delete", "operational_complaint_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32195, 48),
      ))
    }

@delegate:ResourceContentHash(-1_662_252_933)
internal val Res.string.operational_complaint_delete_message: StringResource by lazy {
      StringResource("string:operational_complaint_delete_message", "operational_complaint_delete_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31955, 168),
      ))
    }

@delegate:ResourceContentHash(1_337_555_283)
internal val Res.string.operational_complaint_delete_title: StringResource by lazy {
      StringResource("string:operational_complaint_delete_title", "operational_complaint_delete_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32124, 70),
      ))
    }

@delegate:ResourceContentHash(1_986_871_075)
internal val Res.string.operational_complaint_empty: StringResource by lazy {
      StringResource("string:operational_complaint_empty", "operational_complaint_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32244, 79),
      ))
    }

@delegate:ResourceContentHash(2_087_012_556)
internal val Res.string.operational_complaint_form_title_edit: StringResource by lazy {
      StringResource("string:operational_complaint_form_title_edit", "operational_complaint_form_title_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32324, 73),
      ))
    }

@delegate:ResourceContentHash(1_819_488_362)
internal val Res.string.operational_complaint_indicator_pending: StringResource by lazy {
      StringResource("string:operational_complaint_indicator_pending", "operational_complaint_indicator_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32398, 79),
      ))
    }

@delegate:ResourceContentHash(430_605_414)
internal val Res.string.operational_complaint_indicator_resolved: StringResource by lazy {
      StringResource("string:operational_complaint_indicator_resolved", "operational_complaint_indicator_resolved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32478, 64),
      ))
    }

@delegate:ResourceContentHash(914_784_061)
internal val Res.string.operational_complaint_indicator_top_nature: StringResource by lazy {
      StringResource("string:operational_complaint_indicator_top_nature", "operational_complaint_indicator_top_nature", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32543, 66),
      ))
    }

@delegate:ResourceContentHash(-493_448_615)
internal val Res.string.operational_complaint_indicator_total: StringResource by lazy {
      StringResource("string:operational_complaint_indicator_total", "operational_complaint_indicator_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32610, 77),
      ))
    }

@delegate:ResourceContentHash(-688_507_374)
internal val Res.string.operational_complaint_status_closed: StringResource by lazy {
      StringResource("string:operational_complaint_status_closed", "operational_complaint_status_closed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32688, 55),
      ))
    }

@delegate:ResourceContentHash(-1_888_793_744)
internal val Res.string.operational_complaint_status_in_progress: StringResource by lazy {
      StringResource("string:operational_complaint_status_in_progress", "operational_complaint_status_in_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32744, 64),
      ))
    }

@delegate:ResourceContentHash(1_558_480_393)
internal val Res.string.operational_complaint_status_open: StringResource by lazy {
      StringResource("string:operational_complaint_status_open", "operational_complaint_status_open", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32809, 49),
      ))
    }

@delegate:ResourceContentHash(-1_786_562_990)
internal val Res.string.operational_complaint_status_resolved: StringResource by lazy {
      StringResource("string:operational_complaint_status_resolved", "operational_complaint_status_resolved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32859, 57),
      ))
    }

@delegate:ResourceContentHash(-910_581_172)
internal val Res.string.operational_complaint_view_title: StringResource by lazy {
      StringResource("string:operational_complaint_view_title", "operational_complaint_view_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32917, 72),
      ))
    }

@delegate:ResourceContentHash(1_350_602_227)
internal val Res.string.operational_complaints_by_nature_title: StringResource by lazy {
      StringResource("string:operational_complaints_by_nature_title", "operational_complaints_by_nature_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32990, 78),
      ))
    }

@delegate:ResourceContentHash(1_486_869_744)
internal val Res.string.operational_complaints_by_service_title: StringResource by lazy {
      StringResource("string:operational_complaints_by_service_title", "operational_complaints_by_service_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33069, 83),
      ))
    }

@delegate:ResourceContentHash(-523_355_569)
internal val Res.string.operational_complaints_by_shift_title: StringResource by lazy {
      StringResource("string:operational_complaints_by_shift_title", "operational_complaints_by_shift_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33153, 77),
      ))
    }

@delegate:ResourceContentHash(107_051_119)
internal val Res.string.operational_complaints_by_unit_title: StringResource by lazy {
      StringResource("string:operational_complaints_by_unit_title", "operational_complaints_by_unit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33231, 80),
      ))
    }

@delegate:ResourceContentHash(1_210_174_571)
internal val Res.string.operational_complaints_evolution_legend: StringResource by lazy {
      StringResource("string:operational_complaints_evolution_legend", "operational_complaints_evolution_legend", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33312, 75),
      ))
    }

@delegate:ResourceContentHash(-148_888_231)
internal val Res.string.operational_complaints_evolution_title: StringResource by lazy {
      StringResource("string:operational_complaints_evolution_title", "operational_complaints_evolution_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33388, 98),
      ))
    }

@delegate:ResourceContentHash(1_210_174_571)
internal val Res.string.operational_complaints_total_occurrences: StringResource by lazy {
      StringResource("string:operational_complaints_total_occurrences", "operational_complaints_total_occurrences", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33487, 76),
      ))
    }

@delegate:ResourceContentHash(1_165_880_054)
internal val Res.string.operational_consolidated_axis: StringResource by lazy {
      StringResource("string:operational_consolidated_axis", "operational_consolidated_axis", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33564, 53),
      ))
    }

@delegate:ResourceContentHash(-1_048_691_959)
internal val Res.string.operational_consolidated_empty: StringResource by lazy {
      StringResource("string:operational_consolidated_empty", "operational_consolidated_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33618, 70),
      ))
    }

@delegate:ResourceContentHash(1_863_124_316)
internal val Res.string.operational_consolidated_expense: StringResource by lazy {
      StringResource("string:operational_consolidated_expense", "operational_consolidated_expense", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33689, 56),
      ))
    }

@delegate:ResourceContentHash(1_114_770_570)
internal val Res.string.operational_consolidated_legend_planned: StringResource by lazy {
      StringResource("string:operational_consolidated_legend_planned", "operational_consolidated_legend_planned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33746, 63),
      ))
    }

@delegate:ResourceContentHash(-1_670_186_359)
internal val Res.string.operational_consolidated_legend_real: StringResource by lazy {
      StringResource("string:operational_consolidated_legend_real", "operational_consolidated_legend_real", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33810, 52),
      ))
    }

@delegate:ResourceContentHash(-216_528_140)
internal val Res.string.operational_consolidated_profit: StringResource by lazy {
      StringResource("string:operational_consolidated_profit", "operational_consolidated_profit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33920, 51),
      ))
    }

@delegate:ResourceContentHash(-216_528_140)
internal val Res.string.operational_consolidated_profit_axis: StringResource by lazy {
      StringResource("string:operational_consolidated_profit_axis", "operational_consolidated_profit_axis", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33863, 56),
      ))
    }

@delegate:ResourceContentHash(1_048_661_689)
internal val Res.string.operational_consolidated_result: StringResource by lazy {
      StringResource("string:operational_consolidated_result", "operational_consolidated_result", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33972, 59),
      ))
    }

@delegate:ResourceContentHash(-862_941_664)
internal val Res.string.operational_consolidated_revenue: StringResource by lazy {
      StringResource("string:operational_consolidated_revenue", "operational_consolidated_revenue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34032, 64),
      ))
    }

@delegate:ResourceContentHash(-66_259_850)
internal val Res.string.operational_corporate_admin_others: StringResource by lazy {
      StringResource("string:operational_corporate_admin_others", "operational_corporate_admin_others", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34200, 82),
      ))
    }

@delegate:ResourceContentHash(347_697_086)
internal val Res.string.operational_corporate_admin_others_percent: StringResource by lazy {
      StringResource("string:operational_corporate_admin_others_percent", "operational_corporate_admin_others_percent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34097, 102),
      ))
    }

@delegate:ResourceContentHash(-1_702_871_767)
internal val Res.string.operational_corporate_charges: StringResource by lazy {
      StringResource("string:operational_corporate_charges", "operational_corporate_charges", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34283, 77),
      ))
    }

@delegate:ResourceContentHash(-53_213_619)
internal val Res.string.operational_corporate_payroll: StringResource by lazy {
      StringResource("string:operational_corporate_payroll", "operational_corporate_payroll", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34361, 57),
      ))
    }

@delegate:ResourceContentHash(-564_882_145)
internal val Res.string.operational_corporate_taxes: StringResource by lazy {
      StringResource("string:operational_corporate_taxes", "operational_corporate_taxes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34419, 55),
      ))
    }

@delegate:ResourceContentHash(526_566_680)
internal val Res.string.operational_corporate_title: StringResource by lazy {
      StringResource("string:operational_corporate_title", "operational_corporate_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34475, 63),
      ))
    }

@delegate:ResourceContentHash(-1_648_293_605)
internal val Res.string.operational_costs_axis: StringResource by lazy {
      StringResource("string:operational_costs_axis", "operational_costs_axis", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34539, 46),
      ))
    }

@delegate:ResourceContentHash(1_300_496_352)
internal val Res.string.operational_costs_col_category: StringResource by lazy {
      StringResource("string:operational_costs_col_category", "operational_costs_col_category", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34586, 50),
      ))
    }

@delegate:ResourceContentHash(1_006_797_021)
internal val Res.string.operational_costs_col_share: StringResource by lazy {
      StringResource("string:operational_costs_col_share", "operational_costs_col_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34637, 51),
      ))
    }

@delegate:ResourceContentHash(-1_703_224_615)
internal val Res.string.operational_costs_col_total: StringResource by lazy {
      StringResource("string:operational_costs_col_total", "operational_costs_col_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34689, 51),
      ))
    }

@delegate:ResourceContentHash(-955_848_665)
internal val Res.string.operational_costs_employees: StringResource by lazy {
      StringResource("string:operational_costs_employees", "operational_costs_employees", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34741, 59),
      ))
    }

@delegate:ResourceContentHash(33_904_686)
internal val Res.string.operational_costs_empty: StringResource by lazy {
      StringResource("string:operational_costs_empty", "operational_costs_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34801, 83),
      ))
    }

@delegate:ResourceContentHash(-256_105_337)
internal val Res.string.operational_costs_evolution_title: StringResource by lazy {
      StringResource("string:operational_costs_evolution_title", "operational_costs_evolution_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34885, 81),
      ))
    }

@delegate:ResourceContentHash(2_069_831_774)
internal val Res.string.operational_costs_fopag: StringResource by lazy {
      StringResource("string:operational_costs_fopag", "operational_costs_fopag", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35044, 47),
      ))
    }

@delegate:ResourceContentHash(1_476_786_998)
internal val Res.string.operational_costs_fopag_per_employee: StringResource by lazy {
      StringResource("string:operational_costs_fopag_per_employee", "operational_costs_fopag_per_employee", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34967, 76),
      ))
    }

@delegate:ResourceContentHash(-1_648_293_605)
internal val Res.string.operational_costs_legend_cost: StringResource by lazy {
      StringResource("string:operational_costs_legend_cost", "operational_costs_legend_cost", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35092, 53),
      ))
    }

@delegate:ResourceContentHash(-862_941_664)
internal val Res.string.operational_costs_legend_revenue: StringResource by lazy {
      StringResource("string:operational_costs_legend_revenue", "operational_costs_legend_revenue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35146, 64),
      ))
    }

@delegate:ResourceContentHash(-1_352_892_462)
internal val Res.string.operational_costs_operational: StringResource by lazy {
      StringResource("string:operational_costs_operational", "operational_costs_operational", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35211, 69),
      ))
    }

@delegate:ResourceContentHash(-807_217_784)
internal val Res.string.operational_costs_share_revenue: StringResource by lazy {
      StringResource("string:operational_costs_share_revenue", "operational_costs_share_revenue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35281, 59),
      ))
    }

@delegate:ResourceContentHash(-1_506_424_200)
internal val Res.string.operational_costs_share_title: StringResource by lazy {
      StringResource("string:operational_costs_share_title", "operational_costs_share_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35341, 77),
      ))
    }

@delegate:ResourceContentHash(-1_126_909_734)
internal val Res.string.operational_costs_share_total: StringResource by lazy {
      StringResource("string:operational_costs_share_total", "operational_costs_share_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35419, 57),
      ))
    }

@delegate:ResourceContentHash(-241_868_264)
internal val Res.string.operational_costs_table_title: StringResource by lazy {
      StringResource("string:operational_costs_table_title", "operational_costs_table_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35477, 89),
      ))
    }

@delegate:ResourceContentHash(-269_898_700)
internal val Res.string.operational_costs_top_title: StringResource by lazy {
      StringResource("string:operational_costs_top_title", "operational_costs_top_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35567, 71),
      ))
    }

@delegate:ResourceContentHash(1_726_409_746)
internal val Res.string.operational_costs_total: StringResource by lazy {
      StringResource("string:operational_costs_total", "operational_costs_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35639, 63),
      ))
    }

@delegate:ResourceContentHash(773_638_724)
internal val Res.string.operational_dashboard_consolidado: StringResource by lazy {
      StringResource("string:operational_dashboard_consolidado", "operational_dashboard_consolidado", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35783, 57),
      ))
    }

@delegate:ResourceContentHash(-1_954_587_892)
internal val Res.string.operational_dashboard_consolidado_detalhado: StringResource by lazy {
      StringResource("string:operational_dashboard_consolidado_detalhado", "operational_dashboard_consolidado_detalhado", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35703, 79),
      ))
    }

@delegate:ResourceContentHash(29_589_610)
internal val Res.string.operational_dashboard_custos: StringResource by lazy {
      StringResource("string:operational_dashboard_custos", "operational_dashboard_custos", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35841, 44),
      ))
    }

@delegate:ResourceContentHash(2_062_212_808)
internal val Res.string.operational_dashboard_pessoas: StringResource by lazy {
      StringResource("string:operational_dashboard_pessoas", "operational_dashboard_pessoas", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35886, 49),
      ))
    }

@delegate:ResourceContentHash(-681_146_187)
internal val Res.string.operational_dashboard_por_diretoras: StringResource by lazy {
      StringResource("string:operational_dashboard_por_diretoras", "operational_dashboard_por_diretoras", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35936, 63),
      ))
    }

@delegate:ResourceContentHash(-1_765_089_782)
internal val Res.string.operational_dashboard_por_gestoras: StringResource by lazy {
      StringResource("string:operational_dashboard_por_gestoras", "operational_dashboard_por_gestoras", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36000, 58),
      ))
    }

@delegate:ResourceContentHash(-1_511_565_715)
internal val Res.string.operational_dashboard_por_unidades: StringResource by lazy {
      StringResource("string:operational_dashboard_por_unidades", "operational_dashboard_por_unidades", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36059, 58),
      ))
    }

@delegate:ResourceContentHash(-1_633_783_278)
internal val Res.string.operational_dashboard_reclamacoes: StringResource by lazy {
      StringResource("string:operational_dashboard_reclamacoes", "operational_dashboard_reclamacoes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36118, 61),
      ))
    }

@delegate:ResourceContentHash(-1_252_655_475)
internal val Res.string.operational_dashboard_satisfacao: StringResource by lazy {
      StringResource("string:operational_dashboard_satisfacao", "operational_dashboard_satisfacao", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36180, 56),
      ))
    }

@delegate:ResourceContentHash(-1_157_526_807)
internal val Res.string.operational_dashboard_visao_geral: StringResource by lazy {
      StringResource("string:operational_dashboard_visao_geral", "operational_dashboard_visao_geral", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36237, 57),
      ))
    }

@delegate:ResourceContentHash(2_124_083_168)
internal val Res.string.operational_detailed_categories_title: StringResource by lazy {
      StringResource("string:operational_detailed_categories_title", "operational_detailed_categories_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36295, 73),
      ))
    }

@delegate:ResourceContentHash(1_300_496_352)
internal val Res.string.operational_detailed_col_category: StringResource by lazy {
      StringResource("string:operational_detailed_col_category", "operational_detailed_col_category", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36369, 53),
      ))
    }

@delegate:ResourceContentHash(1_106_947_713)
internal val Res.string.operational_detailed_col_difference: StringResource by lazy {
      StringResource("string:operational_detailed_col_difference", "operational_detailed_col_difference", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36423, 63),
      ))
    }

@delegate:ResourceContentHash(2_980_794)
internal val Res.string.operational_detailed_col_planned: StringResource by lazy {
      StringResource("string:operational_detailed_col_planned", "operational_detailed_col_planned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36487, 64),
      ))
    }

@delegate:ResourceContentHash(1_366_898_220)
internal val Res.string.operational_detailed_col_real: StringResource by lazy {
      StringResource("string:operational_detailed_col_real", "operational_detailed_col_real", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36552, 49),
      ))
    }

@delegate:ResourceContentHash(1_812_506_380)
internal val Res.string.operational_detailed_col_week: StringResource by lazy {
      StringResource("string:operational_detailed_col_week", "operational_detailed_col_week", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36602, 45),
      ))
    }

@delegate:ResourceContentHash(-1_456_502_537)
internal val Res.string.operational_detailed_diff_chart_title: StringResource by lazy {
      StringResource("string:operational_detailed_diff_chart_title", "operational_detailed_diff_chart_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36648, 117),
      ))
    }

@delegate:ResourceContentHash(1_106_947_713)
internal val Res.string.operational_detailed_difference: StringResource by lazy {
      StringResource("string:operational_detailed_difference", "operational_detailed_difference", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36766, 59),
      ))
    }

@delegate:ResourceContentHash(-1_048_691_959)
internal val Res.string.operational_detailed_empty: StringResource by lazy {
      StringResource("string:operational_detailed_empty", "operational_detailed_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36826, 66),
      ))
    }

@delegate:ResourceContentHash(163_298_195)
internal val Res.string.operational_detailed_execution: StringResource by lazy {
      StringResource("string:operational_detailed_execution", "operational_detailed_execution", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36893, 58),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString5Resources(map: MutableMap<String, StringResource>) {
  map.put("operational_add_supplier", Res.string.operational_add_supplier)
  map.put("operational_approved_info", Res.string.operational_approved_info)
  map.put("operational_approved_success", Res.string.operational_approved_success)
  map.put("operational_back", Res.string.operational_back)
  map.put("operational_cancel", Res.string.operational_cancel)
  map.put("operational_clear_confirm", Res.string.operational_clear_confirm)
  map.put("operational_clear_message", Res.string.operational_clear_message)
  map.put("operational_clear_title", Res.string.operational_clear_title)
  map.put("operational_col_line", Res.string.operational_col_line)
  map.put("operational_col_total", Res.string.operational_col_total)
  map.put("operational_company_label", Res.string.operational_company_label)
  map.put("operational_complaint_actions", Res.string.operational_complaint_actions)
  map.put("operational_complaint_add", Res.string.operational_complaint_add)
  map.put("operational_complaint_col_date", Res.string.operational_complaint_col_date)
  map.put("operational_complaint_col_description", Res.string.operational_complaint_col_description)
  map.put("operational_complaint_col_directorate", Res.string.operational_complaint_col_directorate)
  map.put("operational_complaint_col_manager", Res.string.operational_complaint_col_manager)
  map.put("operational_complaint_col_nature", Res.string.operational_complaint_col_nature)
  map.put("operational_complaint_col_owner", Res.string.operational_complaint_col_owner)
  map.put("operational_complaint_col_restaurant", Res.string.operational_complaint_col_restaurant)
  map.put("operational_complaint_col_service", Res.string.operational_complaint_col_service)
  map.put("operational_complaint_col_shift", Res.string.operational_complaint_col_shift)
  map.put("operational_complaint_col_status", Res.string.operational_complaint_col_status)
  map.put("operational_complaint_col_supplier", Res.string.operational_complaint_col_supplier)
  map.put("operational_complaint_col_time", Res.string.operational_complaint_col_time)
  map.put("operational_complaint_col_treatment", Res.string.operational_complaint_col_treatment)
  map.put("operational_complaint_delete", Res.string.operational_complaint_delete)
  map.put("operational_complaint_delete_message", Res.string.operational_complaint_delete_message)
  map.put("operational_complaint_delete_title", Res.string.operational_complaint_delete_title)
  map.put("operational_complaint_empty", Res.string.operational_complaint_empty)
  map.put("operational_complaint_form_title_edit", Res.string.operational_complaint_form_title_edit)
  map.put("operational_complaint_indicator_pending", Res.string.operational_complaint_indicator_pending)
  map.put("operational_complaint_indicator_resolved", Res.string.operational_complaint_indicator_resolved)
  map.put("operational_complaint_indicator_top_nature", Res.string.operational_complaint_indicator_top_nature)
  map.put("operational_complaint_indicator_total", Res.string.operational_complaint_indicator_total)
  map.put("operational_complaint_status_closed", Res.string.operational_complaint_status_closed)
  map.put("operational_complaint_status_in_progress", Res.string.operational_complaint_status_in_progress)
  map.put("operational_complaint_status_open", Res.string.operational_complaint_status_open)
  map.put("operational_complaint_status_resolved", Res.string.operational_complaint_status_resolved)
  map.put("operational_complaint_view_title", Res.string.operational_complaint_view_title)
  map.put("operational_complaints_by_nature_title", Res.string.operational_complaints_by_nature_title)
  map.put("operational_complaints_by_service_title", Res.string.operational_complaints_by_service_title)
  map.put("operational_complaints_by_shift_title", Res.string.operational_complaints_by_shift_title)
  map.put("operational_complaints_by_unit_title", Res.string.operational_complaints_by_unit_title)
  map.put("operational_complaints_evolution_legend", Res.string.operational_complaints_evolution_legend)
  map.put("operational_complaints_evolution_title", Res.string.operational_complaints_evolution_title)
  map.put("operational_complaints_total_occurrences", Res.string.operational_complaints_total_occurrences)
  map.put("operational_consolidated_axis", Res.string.operational_consolidated_axis)
  map.put("operational_consolidated_empty", Res.string.operational_consolidated_empty)
  map.put("operational_consolidated_expense", Res.string.operational_consolidated_expense)
  map.put("operational_consolidated_legend_planned", Res.string.operational_consolidated_legend_planned)
  map.put("operational_consolidated_legend_real", Res.string.operational_consolidated_legend_real)
  map.put("operational_consolidated_profit", Res.string.operational_consolidated_profit)
  map.put("operational_consolidated_profit_axis", Res.string.operational_consolidated_profit_axis)
  map.put("operational_consolidated_result", Res.string.operational_consolidated_result)
  map.put("operational_consolidated_revenue", Res.string.operational_consolidated_revenue)
  map.put("operational_corporate_admin_others", Res.string.operational_corporate_admin_others)
  map.put("operational_corporate_admin_others_percent", Res.string.operational_corporate_admin_others_percent)
  map.put("operational_corporate_charges", Res.string.operational_corporate_charges)
  map.put("operational_corporate_payroll", Res.string.operational_corporate_payroll)
  map.put("operational_corporate_taxes", Res.string.operational_corporate_taxes)
  map.put("operational_corporate_title", Res.string.operational_corporate_title)
  map.put("operational_costs_axis", Res.string.operational_costs_axis)
  map.put("operational_costs_col_category", Res.string.operational_costs_col_category)
  map.put("operational_costs_col_share", Res.string.operational_costs_col_share)
  map.put("operational_costs_col_total", Res.string.operational_costs_col_total)
  map.put("operational_costs_employees", Res.string.operational_costs_employees)
  map.put("operational_costs_empty", Res.string.operational_costs_empty)
  map.put("operational_costs_evolution_title", Res.string.operational_costs_evolution_title)
  map.put("operational_costs_fopag", Res.string.operational_costs_fopag)
  map.put("operational_costs_fopag_per_employee", Res.string.operational_costs_fopag_per_employee)
  map.put("operational_costs_legend_cost", Res.string.operational_costs_legend_cost)
  map.put("operational_costs_legend_revenue", Res.string.operational_costs_legend_revenue)
  map.put("operational_costs_operational", Res.string.operational_costs_operational)
  map.put("operational_costs_share_revenue", Res.string.operational_costs_share_revenue)
  map.put("operational_costs_share_title", Res.string.operational_costs_share_title)
  map.put("operational_costs_share_total", Res.string.operational_costs_share_total)
  map.put("operational_costs_table_title", Res.string.operational_costs_table_title)
  map.put("operational_costs_top_title", Res.string.operational_costs_top_title)
  map.put("operational_costs_total", Res.string.operational_costs_total)
  map.put("operational_dashboard_consolidado", Res.string.operational_dashboard_consolidado)
  map.put("operational_dashboard_consolidado_detalhado", Res.string.operational_dashboard_consolidado_detalhado)
  map.put("operational_dashboard_custos", Res.string.operational_dashboard_custos)
  map.put("operational_dashboard_pessoas", Res.string.operational_dashboard_pessoas)
  map.put("operational_dashboard_por_diretoras", Res.string.operational_dashboard_por_diretoras)
  map.put("operational_dashboard_por_gestoras", Res.string.operational_dashboard_por_gestoras)
  map.put("operational_dashboard_por_unidades", Res.string.operational_dashboard_por_unidades)
  map.put("operational_dashboard_reclamacoes", Res.string.operational_dashboard_reclamacoes)
  map.put("operational_dashboard_satisfacao", Res.string.operational_dashboard_satisfacao)
  map.put("operational_dashboard_visao_geral", Res.string.operational_dashboard_visao_geral)
  map.put("operational_detailed_categories_title", Res.string.operational_detailed_categories_title)
  map.put("operational_detailed_col_category", Res.string.operational_detailed_col_category)
  map.put("operational_detailed_col_difference", Res.string.operational_detailed_col_difference)
  map.put("operational_detailed_col_planned", Res.string.operational_detailed_col_planned)
  map.put("operational_detailed_col_real", Res.string.operational_detailed_col_real)
  map.put("operational_detailed_col_week", Res.string.operational_detailed_col_week)
  map.put("operational_detailed_diff_chart_title", Res.string.operational_detailed_diff_chart_title)
  map.put("operational_detailed_difference", Res.string.operational_detailed_difference)
  map.put("operational_detailed_empty", Res.string.operational_detailed_empty)
  map.put("operational_detailed_execution", Res.string.operational_detailed_execution)
}
